import { useState, useCallback, useRef } from 'react';

export const useSubmissionLock = (options = {}) => {
  const { debounceMs = 300 } = options;
  const [isLocked, setIsLocked] = useState(false);
  const lastSubmitRef = useRef(0);

  const withLock = useCallback(
    async (fn) => {
      const now = Date.now();
      if (now - lastSubmitRef.current < debounceMs) return undefined;
      if (isLocked) return undefined;

      lastSubmitRef.current = now;
      setIsLocked(true);

      try {
        return await fn();
      } finally {
        setIsLocked(false);
      }
    },
    [isLocked, debounceMs]
  );

  return { isLocked, withLock };
};
